import { CustomButton, CustomTextInput } from "@Modules/core/components";
import CustomFormControl from "@Modules/core/components/form/CustomFormControl";
import { IBatchRecordingFormMeta } from '@Modules/cardManagementSystem/prepaid/containers/tableHandlers/card/anonymousCardProduction/batchRecording/BatchRecordingMeta';
import { ChakraComponents as CC } from "@Modules/core/lib/chakra";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FaSave } from "react-icons/fa";


type Props = {
  onSubmit: any,
  meta: IBatchRecordingFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
} 

const BatchRecordingFormUI = ({onSubmit, isLoading, isSubmitting, meta}: Props) => {

    const {
        register,
        handleSubmit,
        formState: { errors },
        // reset,
      } = useForm({ resolver: yupResolver(meta.schema),});
    
  return (
    <>
        <form onSubmit={handleSubmit(onSubmit)}>        
        
        
        <CC.Box as="fieldset" 
       width={'100%'}>          
        <CC.SimpleGrid columns={{base: 1, sm:1, md: 2, lg:3}} spacing={10} my={10}>
          
          <CC.Stack>
            <CC.Text fontWeight={'bold'}>Programme prépayé</CC.Text>
            <CC.Text minW={100} minH={10} bgColor={CC.useColorModeValue('gray.200', 'gray.700')}></CC.Text>
          </CC.Stack>

          <CC.Stack>
            <CC.Text fontWeight={'bold'}>Audience cible</CC.Text>
            <CC.Text minW={100} minH={10} bgColor={CC.useColorModeValue('gray.200', 'gray.700')}></CC.Text>
          </CC.Stack>

          <CC.Stack>
            <CC.Text fontWeight={'bold'}>Produit carte</CC.Text>
            <CC.Text minW={100} minH={10} bgColor={CC.useColorModeValue('gray.200', 'gray.700')}></CC.Text>
          </CC.Stack>

          <CC.Stack>
            <CC.Text fontWeight={'bold'}>Devise compte</CC.Text>
            <CC.Text minW={100} minH={10} bgColor={CC.useColorModeValue('gray.200', 'gray.700')}></CC.Text>
          </CC.Stack>          

          <CC.Stack>
            <CC.Text fontWeight={'bold'}>Catégorie carte</CC.Text>
            <CC.Text minW={100} minH={10} bgColor={CC.useColorModeValue('gray.200', 'gray.700')}></CC.Text>
          </CC.Stack>

        </CC.SimpleGrid>
      </CC.Box>

      

      </form>
    </>    
  )
}

export default BatchRecordingFormUI;